import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

import { PropType, computed } from "vue";
import { DocType, Project } from "@/types";
import { useDocumentsStore } from "@/stores/documents";
import ProjectCardDocument from "./ProjectCardDocument.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectCardDocuments',
  props: {
    project: {
        type: Object as PropType<Project>,
        required: true,
    },
    doctype: {
        type: String as PropType<DocType>,
        required: true,
    },
},
  setup(__props) {

const props = __props;

const documentsStore = useDocumentsStore();

const documents = computed(() => {
    return documentsStore.getDocumentsForProjectOfType(
        props.project.id,
        props.doctype
    );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(documents.value, (document, index) => {
    return (_openBlock(), _createBlock(ProjectCardDocument, {
      key: index,
      document: document
    }, null, 8, ["document"]))
  }), 128))
}
}

})